"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var TextButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TextButton",
  componentId: "sc-dnwg69-0"
})(["background:transparent;color:", ";font-weight:500;cursor:pointer;flex-shrink:0;transition:0.18s;&:hover{color:", ";background-color:", ";}&:active{background-color:", ";}&:disabled{color:", ";cursor:not-allowed;opacity:0.6;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary[1];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary[1];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.dark[6];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[5];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[3];
});
var _default = TextButton;
exports["default"] = _default;